import { WalletType } from "./types";

export const isSmartWallet = (walletType: WalletType): boolean =>
  walletType === WalletType.SMART;
